<script>
  import PageDataSidebar from '@/components/shared_components/page_data/PageDataSidebar';

  export default {
    extends: PageDataSidebar,
    computed: {
      mobTitle() { return this.$gettext('Settings'); },
      navLinksList() {
        const links = [{
          title: this.$gettext('Availability'),
          route: {name: 'ServerPreferencesAvailability'},
          condition: this.userIsInterpreter && !this.isTranslationOnly
        }, {
          title: this.$gettext('Notifications'),
          route: {name: 'BuyerPreferencesNotifications'},
          condition: this.userIsNotInterpreter && !this.isTranslationOnly
        }, {
          title: this.$gettext('Interpretation Notifications'),
          route: {name: 'ServerInterpretationNotifications'},
          condition: this.userIsInterpreter && !this.isTranslationOnly
        }, {
          title: this.$gettext('Translation Notifications'),
          route: {name: 'ServerTranslationNotifications'},
          condition: this.userIsInterpreter && !this.isCourtTheme
        }];

        return links.filter((link) => link.condition);
      }
    }
  };
</script>
